import { render } from "./BatchRoleAssignmentDetail.vue?vue&type=template&id=7163be40&ts=true"
import script from "./BatchRoleAssignmentDetail.vue?vue&type=script&lang=ts"
export * from "./BatchRoleAssignmentDetail.vue?vue&type=script&lang=ts"

import "./BatchRoleAssignmentDetail.vue?vue&type=style&index=0&id=7163be40&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__